import { Pausable } from './Pausable';

export class Timer extends Pausable {
    public get elapsedTime() {
        return Date.now() - this.startTime;
    }

    public get remainingTime() {
        return Math.max(0, this.time - this.elapsedTime);
    }

    public paused: boolean;
    private startTime: number;
    private timer: any;
    private readonly callback: () => void;

    private time: number;

    constructor(time: number, onComplete: () => void, paused = false) {
        super();
        this.time = time;
        this.callback = () => {
            onComplete();
            this.destroy();
        };
        this.startTime = Date.now();
        if (!paused) {
            this.timer = setTimeout(this.callback.bind(this), time);
        }
        this.paused = paused;
    }

    public clear() {
        clearTimeout(this.timer);
    }

    public destroy() {
        this.clear();
        super.destroy();
    }

    public setPaused(paused: boolean) {
        if (paused === this.paused) {
            return;
        }
        if (paused) {
            clearTimeout(this.timer);
            this.time = this.remainingTime;
        } else {
            this.startTime = Date.now();
            if (this.timer) {
                this.clear();
            }
            this.timer = setTimeout(this.callback, this.time);
        }
        this.paused = paused;
    }
}
